export default "__VITE_ASSET__DSXFKG3q__"